<template>
  <div class="work-pic-list">
    <!--    <div class="mod-title">-->
    <!--      <span class="main">办公实况</span><span class="en">work office</span>-->
    <!--    </div>-->
    <div v-if="tempArray.length > 1">
      <vue-seamless-scroll ref="seamlessScroll" :data="tempArray"
                           class="seamless-warp"
                           :class-option="defaultOption">
        <ul class="ul-scroll">
          <li class="img-box" v-for="(item, index) in tempArray" :key='index'>
            <img :src="item.url" alt="加载失败"/>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import '@/util/common';
import {get} from "@/util/Http";
import vueSeamlessScroll from 'vue-seamless-scroll';

export default {
  components: {
    vueSeamlessScroll
  },
  name: 'PicRoll',
  data() {
    return {
      tempArray: [],
      defaultOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        autoPlay: false,
      },
    }
  },
  created() {
    this.getCompanyContact();
  },
  mounted() {
    setTimeout(() => {
      this.defaultOption.autoPlay = true;
      if (this.$refs.seamlessScroll) {
        this.$refs.seamlessScroll.reset();
      }
    }, 4000);
  },
  computed: {},
  methods: {
    getCompanyContact() {
      get('/getCompanyContact')
        .then((result) => {
          if (result.status === 200) {
            this.tempArray = JSON.parse(result.data.contact.img || '[]');
          }
        }).catch((error) => {
        console.log(error);
      });
    },
  }
};
</script>

<style scoped>

.work-pic-list {
  overflow: hidden;

  .ul-scroll {
    overflow: hidden;
    display: flex;
    padding: 0;
    .img-box {
      display: inline-block;
      flex-shrink: 0;
      box-sizing: border-box;
      padding: 0 5px;

      img {
        width: 100%;
        height: 400px;;
        overflow: hidden;
        border-radius: 4px;
      }
    }
  }
}

.seamless-warp {
  height: 400px;
  border-radius: 4px;
  overflow: hidden;

  > div {
    width: 99999px !important;
  }
}
</style>
